export default __webpack_public_path__ + "f477c1b36628cc53cbae02e8fadd0d02.png";